// extracted by mini-css-extract-plugin
export default {"headerRightContentWrapper":"HeaderRight_headerRightContentWrapper__0N2n0","premiumBtnWrapper":"HeaderRight_premiumBtnWrapper__+gQc0"};